import {connect} from 'react-redux';
import {QuestionFooter as Component} from './QuestionFooter';
import {submitQuestionAnswer} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state) {
  return {
    interactionProps: {
      solutions: (state.notebook.protocolSection.scene.hasOwnProperty("apparatus"))?state.notebook.protocolSection.scene.apparatus.solutions:null
    },
    uuid: state.notebook.protocolSection.uuid
  };
}

function mapDispatchToProps(dispatch) {
  return {
    submitAnswer: (id, type, key) => dispatch(submitQuestionAnswer(id, type, key))
  };
}

export const QuestionFooter = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
